namespace TabAurous.Sales {
    export interface ApprovalOutBOMRow {
        TransBomId?: number;
        TransItemId?: number;
        RefTransBomId?: number;
        ProductId?: number;
        BOMProductId?: number;
        BOMAttributeId?: number;
        Lab?: string;
        CertificateNo?: string;
        Pieces?: number;
        Weight?: number;
        CalcOnId?: number;
        SettingId?: number;
        StoneStatusId?: Common.StoneStatus;
        BomRate?: number;
        BomAmount?: number;
        CCBomAmount?: number;
        Remarks?: string;
        Purity?: number;
        PureWeight?: number;
        DiscountPercent?: number;
        Discount?: number;
        Markup?: number;
        PointerWeight?: number;
        Parts?: number;
        TextureId?: number;
        ProductCode?: string;
        ProductName?: string;
        IsCustomerItem?: boolean;
        CostMethodId?: Common.CostMethod;
        CalcOn?: string;
        HasBom?: boolean;
        ItemTypeId?: number;
        ProductTypeId?: number;
        SubCategoryId?: number;
        CategoryId?: number;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        KaratId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Attribute?: string;
        ProductTypeCode?: string;
        ProductTypeName?: string;
        ItemType?: string;
        CategoryCode?: string;
        CategoryName?: string;
        SubCategoryCode?: string;
        SubCategoryName?: string;
        KaratCode?: string;
        KaratName?: string;
        MetalColorCode?: string;
        MetalColorName?: string;
        ProductSizeCode?: string;
        ProductSizeName?: string;
        StoneSizeCode?: string;
        StoneSizeName?: string;
        BrandCode?: string;
        BrandName?: string;
        CollectionCode?: string;
        CollectionName?: string;
        SuperTypeCode?: string;
        SuperTypeName?: string;
        ShapeCode?: string;
        ShapeName?: string;
        SieveCode?: string;
        SieveName?: string;
        GroupSieveCode?: string;
        GroupSieveName?: string;
        QualityCode?: string;
        QualityName?: string;
        StoneColorCode?: string;
        StoneColoreName?: string;
        StampCode?: string;
        StampName?: string;
        MetalCode?: string;
        MetalName?: string;
        StoneCutCode?: string;
        StoneCutName?: string;
        StonePolishCode?: string;
        StonePolishName?: string;
        StoneSymmetryCode?: string;
        StoneSymmetryName?: string;
        StoneFluorescenceCode?: string;
        StoneFluorescenceName?: string;
        StoneCuletCode?: string;
        StoneCuletName?: string;
        StoneGirdleCode?: string;
        StoneGirdleName?: string;
        GrossWeight?: number;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
    }

    export namespace ApprovalOutBOMRow {
        export const idProperty = 'TransBomId';
        export const nameProperty = 'CertificateNo';
        export const localTextPrefix = 'Sales.ApprovalOutBOM';
        export const deletePermission = 'Sales:Approval:Delete';
        export const insertPermission = 'Sales:Approval:Add';
        export const readPermission = '*';
        export const updatePermission = 'Sales:Approval:Edit';

        export declare const enum Fields {
            TransBomId = "TransBomId",
            TransItemId = "TransItemId",
            RefTransBomId = "RefTransBomId",
            ProductId = "ProductId",
            BOMProductId = "BOMProductId",
            BOMAttributeId = "BOMAttributeId",
            Lab = "Lab",
            CertificateNo = "CertificateNo",
            Pieces = "Pieces",
            Weight = "Weight",
            CalcOnId = "CalcOnId",
            SettingId = "SettingId",
            StoneStatusId = "StoneStatusId",
            BomRate = "BomRate",
            BomAmount = "BomAmount",
            CCBomAmount = "CCBomAmount",
            Remarks = "Remarks",
            Purity = "Purity",
            PureWeight = "PureWeight",
            DiscountPercent = "DiscountPercent",
            Discount = "Discount",
            Markup = "Markup",
            PointerWeight = "PointerWeight",
            Parts = "Parts",
            TextureId = "TextureId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            IsCustomerItem = "IsCustomerItem",
            CostMethodId = "CostMethodId",
            CalcOn = "CalcOn",
            HasBom = "HasBom",
            ItemTypeId = "ItemTypeId",
            ProductTypeId = "ProductTypeId",
            SubCategoryId = "SubCategoryId",
            CategoryId = "CategoryId",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Attribute = "Attribute",
            ProductTypeCode = "ProductTypeCode",
            ProductTypeName = "ProductTypeName",
            ItemType = "ItemType",
            CategoryCode = "CategoryCode",
            CategoryName = "CategoryName",
            SubCategoryCode = "SubCategoryCode",
            SubCategoryName = "SubCategoryName",
            KaratCode = "KaratCode",
            KaratName = "KaratName",
            MetalColorCode = "MetalColorCode",
            MetalColorName = "MetalColorName",
            ProductSizeCode = "ProductSizeCode",
            ProductSizeName = "ProductSizeName",
            StoneSizeCode = "StoneSizeCode",
            StoneSizeName = "StoneSizeName",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            CollectionCode = "CollectionCode",
            CollectionName = "CollectionName",
            SuperTypeCode = "SuperTypeCode",
            SuperTypeName = "SuperTypeName",
            ShapeCode = "ShapeCode",
            ShapeName = "ShapeName",
            SieveCode = "SieveCode",
            SieveName = "SieveName",
            GroupSieveCode = "GroupSieveCode",
            GroupSieveName = "GroupSieveName",
            QualityCode = "QualityCode",
            QualityName = "QualityName",
            StoneColorCode = "StoneColorCode",
            StoneColoreName = "StoneColoreName",
            StampCode = "StampCode",
            StampName = "StampName",
            MetalCode = "MetalCode",
            MetalName = "MetalName",
            StoneCutCode = "StoneCutCode",
            StoneCutName = "StoneCutName",
            StonePolishCode = "StonePolishCode",
            StonePolishName = "StonePolishName",
            StoneSymmetryCode = "StoneSymmetryCode",
            StoneSymmetryName = "StoneSymmetryName",
            StoneFluorescenceCode = "StoneFluorescenceCode",
            StoneFluorescenceName = "StoneFluorescenceName",
            StoneCuletCode = "StoneCuletCode",
            StoneCuletName = "StoneCuletName",
            StoneGirdleCode = "StoneGirdleCode",
            StoneGirdleName = "StoneGirdleName",
            GrossWeight = "GrossWeight",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId"
        }
    }
}
